export default __webpack_public_path__ + "static/media/inbound.49b9814f.svg";